





































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class PopUpGeneratedReports extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: '' }) text!: string;

  handleCloseReport(): void {
    this.$emit('cerrar');
  }
}
